import { render, staticRenderFns } from "./AddPriceForTypeModal.vue?vue&type=template&id=787414b0&scoped=true&"
import script from "./AddPriceForTypeModal.vue?vue&type=script&lang=js&"
export * from "./AddPriceForTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787414b0",
  null
  
)

export default component.exports